import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnsDirective,
  EditSettingsModel,
  ExcelExport,
  GridComponent,
  Group,
  Inject,
} from '@syncfusion/ej2-react-grids';
import {
  Edit,
  Toolbar,
  FilterSettingsModel,
  Filter,
  PageSettingsModel,
  Page,
  ColumnMenu,
  Resize,
} from '@syncfusion/ej2-react-grids';
import * as React from 'react';
import {
  DialogComponent,
  AnimationSettingsModel,
  ButtonPropsModel,
} from '@syncfusion/ej2-react-popups';
import {
  ColorPickerComponent,
  TextBoxComponent,
} from '@syncfusion/ej2-react-inputs';
import './style.css';
import { TimePickerComponent } from '@syncfusion/ej2-react-calendars';
import { getValue } from '@syncfusion/ej2-base';
import { SwitchComponent } from '@syncfusion/ej2-react-buttons';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import 'react-jquery-plugin';
import ReactDOM from 'react-dom';
import { loadingShow } from '../../App';
import Message from '../../utils/Message/Message';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { BiX } from 'react-icons/bi';
import { BsCheck2 } from 'react-icons/bs';
import { ThemeContext } from '../../context/theme.context';
import { getElementAlias } from '../../services/Settings/ElementAlias';
import {
  AddRoster,
  GetRosters,
  ShiftElementDelete,
  ShiftElementUpdate,
} from '../../services/Settings/Roster';
function parseTime(timeString: string) {
  const [hour, minute] = timeString.split(':').map(Number);

  const formattedHour = hour.toString().padStart(2, '0');
  const formattedMinute = minute.toString().padStart(2, '0');

  return {
    hour: formattedHour,
    minute: formattedMinute,
  };
}
interface IProps {}
interface IState {
  rosterData: [];
  hideDialog: boolean;
  hideDialogDelete: boolean;
  endDate: Date;
  showEndDate: boolean;
  capacityDate: Date;
  showCapacitDate: boolean;
  disabledControl: boolean;
  shiftColor: any;
  isTemplate: boolean;
  disabledColor: boolean;
  isEdit: boolean;
  elementAliasData: any;
  selectedElementAlias: any;
}
export default class TableRoster extends React.Component<IProps, IState> {
  public customAttributes: any = { class: 'customcss' };
  public editOptions: EditSettingsModel = {
    allowAdding: false,
    allowDeleting: false,
    allowEditing: false,
    allowEditOnDblClick: false,
    showConfirmDialog: false,
    showDeleteConfirmDialog: false,
  };
  public shipFormat: object = { type: 'date', format: 'dd/MM/yyyy' };
  private ElementType: any = ['Shift', 'Exception'];
  private elementAliasType = {
    text: 'element_alias_name',
    value: 'element_alias_id',
  };
  public toolbarOptions = [
    {
      text: 'Add',
      tooltipText: 'Add',
      prefixIcon: 'e-add',
      id: 'add',
    },
    {
      text: 'Edit',
      tooltipText: 'Edit',
      prefixIcon: 'e-edit',
      id: 'edit',
    },
    {
      text: 'Delete',
      tooltipText: 'Delete',
      prefixIcon: 'e-delete',
      id: 'delete',
    },
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  private buttons: ButtonPropsModel[];
  private buttonsDelete: ButtonPropsModel[];
  private grid: any;
  private animationSettings: AnimationSettingsModel;
  private time: Date = new Date('8/3/2017 10:00');
  static contextType = ThemeContext;
  context!: React.ContextType<typeof ThemeContext>;
  constructor(props: IProps) {
    super(props);
    this.animationSettings = { effect: 'Zoom', duration: 400, delay: 0 };
    this.buttonsDelete = [
      {
        click: () => {
          this.ShiftElementDelete();
        },
        buttonModel: {
          content: 'Yes',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({ hideDialogDelete: false });
        },
        buttonModel: {
          content: 'No',
        },
      },
    ];
    this.buttons = [
      {
        click: () => {
          this.addRoster();
        },
        buttonModel: {
          content: 'Save',
          isPrimary: true,
        },
      },
      {
        click: () => {
          this.setState({
            hideDialog: false,
            isTemplate: true,
            shiftColor: '#d2d2d2',
            isEdit: false,
          });
        },
        buttonModel: {
          content: 'Cancel',
        },
      },
    ];
    this.state = {
      rosterData: [],
      hideDialog: false,
      hideDialogDelete: false,
      endDate: this.time,
      showEndDate: false,
      capacityDate: this.time,
      showCapacitDate: false,
      disabledControl: false,
      shiftColor: '#d2d2d2',
      isTemplate: true,
      disabledColor: false,
      isEdit: false,
      elementAliasData: [],
      selectedElementAlias: '',
    };
  }

  addRoster = () => {
    loadingShow(true);
    var shiftElementId = $('#shiftElementId').val() as any;
    var code = $('#element').val();
    var elementType = $('#elementType').val();
    var elementAlias = $('#elementAlias').val();
    var Description = $('#rosterDescription').val();
    var sHour = $('#datetimepickerStart').val() as any;
    var eHour = $('#datetimepickerEnd').val() as any;
    var duration = $('#duration').val() as any;
    var rostered = $('#isRostered').is(':checked');
    var breakTime = $('#breakTime').val() as any;
    var capacity = $('#capacityHour').val() as string;
    const capacityHour = parseInt(capacity?.split(':')[0]);
    const capacityMinute = parseInt(capacity?.split(':')[1]);
    var capactiyCalculate = capacityHour * 60 + capacityMinute;
    if (code === '') {
      toast.error('Roster code cannot be empty');
      loadingShow(false);
      return false;
    }
    if (Description === '') {
      toast.error('Description cannot be empty');
      loadingShow(false);
      return false;
    }
    if (rostered === true && sHour === '') {
      toast.error('Start hour cannot be empty');
      loadingShow(false);
      return false;
    }
    if (rostered === true && duration === '') {
      toast.error('Duration  cannot be empty');
      loadingShow(false);
      return false;
    }
    if (elementType === '') {
      toast.error('Element type cannot be empty');
      loadingShow(false);
      return false;
    }
    if (rostered === true && breakTime === '') {
      toast.error('Breakt time cannot be empty');
      loadingShow(false);
      return false;
    }
    var color = '';
    this.state.elementAliasData.map((res: any) => {
      if (res.element_alias_name === elementAlias) {
        color = res.Colour;
      }
    });
    var obj: any = {
      startTime: sHour,
      rosterCode: code,
      isrostered: rostered,
      description: Description,
      breakTime: breakTime,
      elementAliasValue: elementAlias,
      endTime: eHour,
      capacity:
        elementType === 'Shift' ? capactiyCalculate : -capactiyCalculate,
      duration: duration,
      rostercolor: color,
      rosterType: elementType,
      ROSTER_NAME: '',
    };

    if (parseInt(shiftElementId) > 0) {
      obj.rosterId = parseInt(shiftElementId);
      ShiftElementUpdate(obj)
        .then((result) => {
          if (result.status === 200) {
            this.getRosters();
            loadingShow(false);
            this.context.setDataChangeShiftTemplate(true);
            Message.success('Update successful...');
            this.dialogClose();
          }
        })
        .catch((err) => {
          loadingShow(false);
          Message.error('Update failed!!!');
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    } else {
      AddRoster(obj)
        .then((result) => {
          this.getRosters();
          loadingShow(false);
          this.context.setDataChangeShiftTemplate(true);
          Message.success('Add successful...');
          this.dialogClose();
        })
        .catch((err) => {
          loadingShow(false);
          Message.error('Add failed!!!');
          if (err.response) {
            Message.error(err.response.data);
            Message.error(err.response.status);
            Message.error(err.response.headers);
          } else if (err.request) {
            Message.error(err.request);
          } else {
            Message.error('Error: ' + err.message);
          }
        });
    }
  };
  private dialogOpenDelete(): void {
    this.setState({ hideDialogDelete: true });
  }
  componentDidUpdate() {
    if (this.context.isDataChangeShiftElement) {
      this.getElementAlias();
      this.context.setDataChangeShiftElement(false);
    }
  }
  private dialogCloseDelete(): void {
    this.setState({
      hideDialogDelete: false,
    });
  }
  private dialogClose(): void {
    this.setState({
      hideDialog: false,
      showEndDate: false,
      showCapacitDate: false,
      isTemplate: true,
      shiftColor: '#d2d2d2',
      isEdit: false,
    });
  }
  private dialogOpen(): void {
    this.setState({ hideDialog: true });
  }
  begin(args: any) {
    if (args.requestType === 'beginEdit') {
      alert('edit');
    }
    if (args.requestType === 'save') {
      alert('save');
    }
  }
  toolbarClick(args: any) {
    if (args.item.id === 'add') {
      this.setState({
        hideDialog: true,
        isTemplate: true,
      });
    }
    if (args.item.id === 'edit') {
      if (this.grid.getSelectedRecords().length !== 0) {
        const data = this.grid.getSelectedRecords()[0];

        setTimeout(() => {
          this.getShiftElementDetails(data);
        }, 125);
        this.setState({ hideDialog: true, isEdit: true });
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'delete') {
      if (this.grid.getSelectedRecords().length !== 0) {
        this.dialogOpenDelete();
      } else {
        Message.error('no records selected for edited operation');
      }
    }
    if (args.item.id === 'refresh') {
      this.getRosters();
    }
    if (this.grid && args.item.id === 'gridTableRoster_excelexport') {
      this.grid.excelExport();
    }
  }
  componentDidMount() {
    this.getRosters();
    this.getElementAlias();
  }
  getElementAlias() {
    getElementAlias(false).then((res) => {
      this.setState({ elementAliasData: res.data });
    });
  }
  ShiftElementDelete() {
    const data: any = this.grid.getSelectedRecords();
    var obj: any = {
      rosterId: data[0].rosterId,
    };

    ShiftElementDelete(obj)
      .then((result) => {
        if (result.status === 200) {
          this.getRosters();
          loadingShow(false);
          Message.success('Delete successful...');
          this.context.setDataChangeShiftTemplate(true);
          this.dialogCloseDelete();
        }
      })
      .catch((err) => {
        loadingShow(false);
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
      });
  }
  getShiftElementDetails = (data: any) => {
    this.setState({
      showCapacitDate: true,
      showEndDate: true,
    });
    $('#element').val(data.rosterCode);
    $('#elementType').val(data.rosterType);
    $('#rosterDescription').val(data.description);
    $('#datetimepickerStart').val(data.startTime);
    $('#datetimepickerEnd').val(data.endTime);
    $('#elementAlias').val(data.elementAliasValue);
    this.setState({
      isTemplate: data.isrostered,
    });
    $('#duration').val(data.duration);
    $('#breakTime').val(data.breakTime);
    $('#capacityHour').val(this.CapacityToTime(data.capacity, true));
    $('#shiftElementId').val(data.rosterId);
  };
  getRosters = () => {
    GetRosters().then((res) => {
      var model = res.data.map((data: any) => {
        return {
          ...data,
          capacity: this.CapacityToTime(data.capacity),
        };
      });
      this.setState({ rosterData: model });
    });
  };

  CapacityToTime(capacity: any, isedit?: boolean) {
    const controlCapacity = capacity?.toString().replace('-', '');
    if (controlCapacity === undefined) {
      return '00:00';
    } else {
      if (isedit) {
        const time = parseTime(controlCapacity);

        return time.hour + ':' + time.minute;
      }

      var sec_num = parseInt(controlCapacity); // don't forget the second param

      var hours = (sec_num / 60)?.toString().split('.')[0];
      var minutes = sec_num - parseInt(hours) * 60;

      var resultHour = hours?.toString();
      var resultMinutes = minutes?.toString();
      if (parseInt(hours) < 10) {
        resultHour = '0' + hours;
      }
      if (minutes < 10) {
        resultMinutes = '0' + minutes;
      }
      return resultHour + ':' + resultMinutes;
    }
  }
  public onChangeStartTime(e: any) {
    if (e.value !== null || e.value !== undefined) {
      this.onChangeDuration();
    }
  }
  public onChangeDuration() {
    var controlDuration = $('#duration').val() as any;

    if (controlDuration === '00:00:00') {
      Message.error('duration cannot be 00:00:00');
      $('#duration').val('');
      return false;
    }

    //starttime calculate
    var startTime = $('#datetimepickerStart').val() as any;
    var startHour = parseInt(startTime.split(':')[0]);
    var startMinutes = parseInt(startTime.split(':')[1]);
    const calcStartTime = (startHour * 60 * 60 + startMinutes * 60) * 1000;
    //duration calculate
    const durationHour = parseInt(controlDuration.split(':')[0]);
    const durationMinute = parseInt(controlDuration.split(':')[1]);
    var date = new Date(Date.now());
    date.setHours(durationHour);
    date.setMinutes(durationMinute);
    var newDate = date.setTime(date.getTime() + calcStartTime);
    var result = new Date(newDate);
    this.setState({ endDate: result, showEndDate: true });

    if (controlDuration !== undefined) {
      this.onChangeBreakTime();
    }
  }
  public onChangeBreakTime() {
    const breakTime = $('#breakTime').val() as any;
    var duration = $('#duration').val() as any;
    var startHour = parseInt(duration.split(':')[0]);
    var startMinutes = parseInt(duration.split(':')[1]);
    var date = new Date(Date.now());
    date.setHours(breakTime.split(':')[0]);
    date.setMinutes(breakTime.split(':')[1]);

    const DateControl = new Date(date);
    if (DateControl.getHours() > startHour) {
      Message.error('Cannot be older than Break-time Duration');
      $('#breakTime').val('');
      return false;
    }
    if (
      DateControl.getHours() === startHour &&
      DateControl.getMinutes() > startMinutes
    ) {
      Message.error('Cannot be older than Break-time Duration');
      $('#breakTime').val('');
      return false;
    }
    var newDate = DateControl.setHours(startHour - DateControl.getHours());
    newDate = DateControl.setMinutes(startMinutes - DateControl.getMinutes());
    var result = new Date(newDate);
    this.setState({ capacityDate: result, showCapacitDate: true });
  }
  cellRender = (args: any) => {
    if ((args.column as Column).field === 'rostercolor') {
      const val = getValue((args.column as Column).field, args.data);
      ReactDOM.render(
        <div
          style={{
            backgroundColor: val,
            width: '15px',
            height: '15px',
            borderRadius: '20%',
            marginLeft: '10%',
          }}
        ></div>,
        args.cell as Element
      );
    }
    if ((args.column as Column).field === 'isrostered') {
      const val = getValue((args.column as Column).field, args.data);
      if (val) {
        ReactDOM.render(
          <div>
            <BsCheck2 size={20} color='green' />
          </div>,
          args.cell as Element
        );
      } else {
        ReactDOM.render(
          <div>
            <BiX size={20} color='red' />
          </div>,
          args.cell as Element
        );
      }
    }
  };
  public onChangeTemplate(e: any) {
    this.setState({ isTemplate: !this.state.isTemplate });

    if (!this.state.isTemplate) {
      $('#pasiveDiv').addClass('disabledDiv');
    } else {
      $('#pasiveDiv').removeClass('disabledDiv');
    }
  }
  public onChangeElementAlias(e: any) {
    const val = $('#elementAlias').val() as string;
    var defaultColor: string = '';
    var color: string = '';
    this.state.rosterData.map((result: any) => {
      if (this.state.isEdit) defaultColor = result.rostercolor;
      else defaultColor = '#d2d2d2';
      let alias = null;
      let value = val.replace(' ', '').toLowerCase().trim();
      if (result.elementAliasValue) {
        alias = result.elementAliasValue.replace(' ', '').toLowerCase().trim();
      }
      if (alias === value) {
        color = result.rostercolor;
      }
    });
    if (color) {
      this.setState({ shiftColor: color, disabledColor: true });
    } else {
      this.setState({ shiftColor: defaultColor, disabledColor: false });
    }
  }
  onChangeElementType = (value: any) => {
    const timeEndShift: Date = new Date('8/3/2022 16:00');
    const timeEndException: Date = new Date('8/3/2022 23:59');

    const timeCapacityShift: Date = new Date('8/3/2022 08:00');
    const timeCapacityException: Date = new Date('8/3/2022 23:59');

    if (value.value === 'Shift') {
      $('#datetimepickerStart').val('08:00');
      $('#duration').val('08:00');
      this.setState({ endDate: timeEndShift });
      $('#breakTime').val('00:00');
      this.setState({ capacityDate: timeCapacityShift });
    } else {
      $('#datetimepickerStart').val('00:00');
      $('#duration').val('23:59');
      this.setState({ endDate: timeEndException });
      $('#breakTime').val('00:00');
      this.setState({ capacityDate: timeCapacityException });
    }
    this.setState({
      showCapacitDate: true,
      showEndDate: true,
    });
  };
  public render() {
    return (
      <div>
        <GridComponent
          id='gridShiftElement'
          dataSource={this.state.rosterData}
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          ref={(g) => (this.grid = g)}
          height='calc(-220px + 100vh)'
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.begin.bind(this)}
          queryCellInfo={this.cellRender}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='rostercolor'
              headerText='#'
              textAlign='Left'
              width={50}
            />
            <ColumnDirective
              field='rosterCode'
              headerText='Element'
              textAlign='Left'
            />
            <ColumnDirective
              field='elementAliasValue'
              headerText='Element Alias'
              textAlign='Left'
            />
            <ColumnDirective
              field='description'
              headerText='Description'
              textAlign='Left'
            />
            <ColumnDirective
              field='rosterType'
              headerText='Element Type'
              textAlign='Left'
            />
            <ColumnDirective
              field='isrostered'
              headerText='Template'
              textAlign='Left'
            />
            <ColumnDirective
              field='startTime'
              headerText='Start'
              textAlign='Left'
            />
            <ColumnDirective
              field='duration'
              headerText='Shift Duration'
              textAlign='Left'
            />
            <ColumnDirective
              field='endTime'
              headerText='End'
              textAlign='Left'
            />
            <ColumnDirective
              field='breakTime'
              headerText='Break-Time'
              textAlign='Left'
            />
            <ColumnDirective
              field='capacity'
              headerText='Capacity Hours'
              textAlign='Left'
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Resize,
              Group,
            ]}
          />
        </GridComponent>
        <div className='control-pane-dialog'>
          <div
            id='targetElement'
            className='col-lg-12 defaultDialog dialog-target'
          >
            {this.state.hideDialog ? (
              <DialogComponent
                isModal={true}
                id='defaultdialog'
                showCloseIcon={true}
                animationSettings={this.animationSettings}
                visible={this.state.hideDialog}
                header='Elements'
                width={700}
                height={'auto'}
                buttons={this.buttons}
                open={this.dialogOpen.bind(this)}
                close={this.dialogClose.bind(this)}
              >
                <div className='container'>
                  <div className='row'>
                    <div className='col-md-12'>
                      <div className='col-md-6'>
                        <div className='col-md-12'>
                          <TextBoxComponent
                            id='element'
                            placeholder='Element'
                            floatLabelType={'Always'}
                          />
                        </div>
                        <div className='col-md-12'>
                          <DropDownListComponent
                            id='elementType'
                            dataSource={this.ElementType}
                            placeholder='Element Type'
                            floatLabelType={'Always'}
                            onChange={this.onChangeElementType}
                          />
                        </div>
                        <div className='col-md-12'>
                          <DropDownListComponent
                            id='elementAlias'
                            fields={this.elementAliasType}
                            dataSource={this.state.elementAliasData}
                            //value={this.ElementAliasValue}
                            placeholder='Element Alias'
                            floatLabelType={'Always'}
                            onChange={this.onChangeElementAlias.bind(this)}
                          />
                        </div>
                        <div className='col-md-12'>
                          <TextBoxComponent
                            id='rosterDescription'
                            placeholder='Description'
                            floatLabelType={'Always'}
                            enableRtl={false}
                          />
                        </div>
                        <div className='col-md-12'>
                          <div className='ColorAndRostered'>
                            <div style={{ textAlign: 'right' }}>
                              <h5 style={{ marginBottom: '10px' }}>Template</h5>
                              <SwitchComponent
                                id='isRostered'
                                style={{ width: '60px' }}
                                cssClass='custom-iOS'
                                onChange={this.onChangeTemplate.bind(this)}
                                checked={this.state.isTemplate}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className='col-md-6' id='pasiveDiv'>
                        <div className='col-md-12'>
                          <TimePickerComponent
                            id='datetimepickerStart'
                            strictMode={false}
                            floatLabelType={'Always'}
                            onChange={this.onChangeStartTime.bind(this)}
                            placeholder='Start Time'
                            format={'HH:mm'}
                          />
                        </div>
                        <div className='col-md-12'>
                          <TimePickerComponent
                            id='duration'
                            strictMode={true}
                            floatLabelType={'Always'}
                            placeholder='Duration(Hours)'
                            onChange={this.onChangeDuration.bind(this)}
                            step={15}
                            format={'HH:mm'}
                          />
                        </div>
                        <div className='col-md-12 disabledDiv'>
                          {this.state.showEndDate === true ? (
                            <TimePickerComponent
                              id='datetimepickerEnd'
                              value={this.state.endDate}
                              strictMode={true}
                              floatLabelType={'Always'}
                              placeholder='End Time'
                              step={30}
                              format={'HH:mm'}
                            />
                          ) : null}
                        </div>
                        <div className='col-md-12'>
                          <TimePickerComponent
                            id='breakTime'
                            strictMode={true}
                            floatLabelType={'Always'}
                            placeholder='Break-Time(Hours)'
                            style={{ overflowY: 'auto' }}
                            onChange={this.onChangeBreakTime.bind(this)}
                            step={15}
                            format={'HH:mm'}
                          />
                        </div>

                        <div className='col-md-12 disabledDiv'>
                          {this.state.showCapacitDate === true ? (
                            <TimePickerComponent
                              id='capacityHour'
                              strictMode={true}
                              value={this.state.capacityDate}
                              floatLabelType={'Always'}
                              placeholder='Capacity Hours'
                              step={15}
                              format={'HH:mm'}
                            />
                          ) : null}
                        </div>
                        <div className='col-md-12'>
                          <input
                            type='text'
                            style={{ visibility: 'hidden' }}
                            id='shiftElementId'
                          ></input>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </DialogComponent>
            ) : null}
          </div>
        </div>
        <div className='control-pane-dialog-delete'>
          <div
            id='targetElementDelete'
            className='col-lg-12 defaultDialogDelete dialog-target'
          >
            <DialogComponent
              isModal={true}
              id='defaultDialogDelete'
              showCloseIcon={true}
              animationSettings={this.animationSettings}
              visible={this.state.hideDialogDelete}
              header='Confirmation'
              width={200}
              height={'auto'}
              buttons={this.buttonsDelete}
              open={this.dialogOpenDelete.bind(this)}
              close={this.dialogCloseDelete.bind(this)}
            >
              <div className='container'>
                <div className='row'>
                  <span>Are you sure?</span>
                </div>
              </div>
            </DialogComponent>
          </div>
        </div>
      </div>
    );
  }
}
